import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GetAllCategoriesAPI, GetBranchCategoriesAPI } from "../../ApiRequests";

const branch = localStorage.getItem("branch");

export const fetchCategories = createAsyncThunk("fetch/category", async () => {
  try {
    let response;
    if (branch) {
      response = await GetBranchCategoriesAPI(branch);
    } else {
      response = await GetAllCategoriesAPI();
    }
    if (!response.data?.success) {
      showErrorToast(response.data.error.msg);
    } else if (response.data?.success) {
      return response.data.data.payload;
    }
  } catch (error) {
    console.log(error);
  }
  return [];
});

const CategorySlice = createSlice({
  name: "category-data",
  initialState: {
    loading: false,
    data: [],
    isError: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCategories.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchCategories.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchCategories.rejected, (state, action) => {
      state.isError = true;
      console.log("Error: ", action.error);
    });
  },
});

export default CategorySlice.reducer;
